import { InjectionKey } from "@lib/svelte-typed-context";

import { ModalManager } from "./ModalManager";

export const modalManagerContextKey: InjectionKey<ModalManager> =
    Symbol("modalManager");
